import React from 'react';

import styled from 'styled-components';

import { canViewShopperCommunication, isMysteryShopAdmin, isMysteryShopShopper } from 'helpers/permissions';
import { useAppSelector } from 'store/hook';

import EditShopRequestModalChecklist from './EditShopRequestModalChecklist';
import EditShopRequestModalCommunityContacts from './EditShopRequestModalCommunityContacts';
import EditShopRequestModalCommunityInfo from './EditShopRequestModalCommunityInfo';
import { useEditShopRequestModalContext } from './EditShopRequestModalContext';
import EditShopRequestModalDates from './EditShopRequestModalDates';
import EditShopRequestModalEnterData from './EditShopRequestModalEnterData';
import EditShopRequestModalHeader from './EditShopRequestModalHeader';
import EditShopRequestModalNotes from './EditShopRequestModalNotes';
import EditShopRequestModalPricingOptions from './EditShopRequestModalPricingOptions';
import EditShopRequestModalReviewData from './EditShopRequestModalReviewData';
import EditShopRequestModalStaticData from './EditShopRequestModalStaticData';
import { SHOP_REQUEST_TYPE } from '../constants';
import EditShopRequestModalShopperEmails from './ShopperEmails/EditShopRequestModalShopperEmails';

const Container = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;
  flex: 1;
  min-height: 0;
`;

const Content = styled.div`
  display: flex;
  flex-flow: row;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

const MainInfo = styled.div`
  display: flex;
  flex-flow: column;
  flex-shrink: 0;
  min-width: 0;
`;

const Row = styled.div`
  display: flex;
  flex-flow: row;
  flex-grow: 1;
  min-height: 0;
  min-width: 0;
  overflow-y: auto;
  padding: 20px 5px 0 30px;
  border-right: solid 1px var(--line-gray);
  gap: 20px;
`;

const Column = styled.div`
  display: flex;
  flex-flow: column;
  flex-shrink: 0;
  width: 370px;
  overflow-y: auto;
`;

const EditShopRequestModalContent = () => {
  const { currentUser } = useAppSelector((state) => state.auth);
  const { shopRequest } = useEditShopRequestModalContext();
  const isShopRequestAdmin = currentUser && isMysteryShopAdmin(currentUser);
  const isShopRequestShopper = currentUser && isMysteryShopShopper(currentUser);
  const showShopperCommunication = canViewShopperCommunication(currentUser);
  const isPricingRequest = shopRequest?.request_type === SHOP_REQUEST_TYPE.MYSTERY_SHOP;

  return (
    <Container>
      <EditShopRequestModalHeader />
      <Content>
        <Row>
          <MainInfo>
            <EditShopRequestModalCommunityInfo />
            {isPricingRequest && <EditShopRequestModalPricingOptions />}
            {showShopperCommunication && <EditShopRequestModalShopperEmails />}
            <EditShopRequestModalCommunityContacts />
          </MainInfo>
          <EditShopRequestModalNotes />
        </Row>
        <Column>
          {isPricingRequest && isShopRequestShopper && <EditShopRequestModalEnterData />}
          {isShopRequestAdmin && <EditShopRequestModalDates />}
          {isPricingRequest && <EditShopRequestModalStaticData />}
          {isPricingRequest && isShopRequestAdmin && <EditShopRequestModalReviewData />}
          <EditShopRequestModalChecklist />
        </Column>
      </Content>
    </Container>
  );
};

export default EditShopRequestModalContent;
